<template>
  <div class="elite-tabs-wrapper-content">
    <h3>{{ salesInvoice.code }}</h3>
    <div class="col-12">
      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.created_at | moment("LLLL") }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">
          {{ $t("SALES_INVOICES.EXPIRATION_TIME") }}
        </dt>
        <dd class="col-sm-8">
          {{ salesInvoice.expiration_time | moment("LLLL") }}
        </dd>
      </dl>
      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.LOCATIONS") }}</dt>
        <dd class="col-sm-8">
          <locations :locations="salesInvoice.allowedLocations" />
        </dd>
      </dl>
      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.ORGANIZATION") }}</dt>
        <dd class="col-sm-8">
          <organization :organization="salesInvoice.organization" />
        </dd>
      </dl>

      <dl class="row" v-if="salesInvoice.salesInvoice">
        <dt class="col-sm-4">{{ $t("COMMON.SALES_ORDER") }}</dt>
        <dd class="col-sm-8">
          <object-link :object="salesInvoice.salesInvoice" />
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.RECIPIENT") }}</dt>
        <dd class="col-sm-8">
          <object-link :object="salesInvoice.recipient" />
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.STATUS") }}</dt>
        <dd class="col-sm-8">
          <sales-invoice-status-badge :salesInvoice="salesInvoice" />
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.TOTAL") }}</dt>
        <dd class="col-sm-8" v-if="salesInvoice.pricing">
          <span> {{ $formatCurrency(salesInvoice.pricing.total) }} </span>
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.TOTAL_PAIED") }}</dt>
        <dd class="col-sm-8">
          <span>
            {{
              $formatCurrency(
                salesInvoice.total_paied ? salesInvoice.total_paied : 0
              )
            }}
          </span>
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4" v-if="salesInvoice.excerpt">
          {{ $t("COMMON.NOTE") }}
        </dt>
        <dd class="col-sm-8" v-if="salesInvoice.excerpt">
          <div v-html="salesInvoice.excerpt"></div>
        </dd>
      </dl>

      <div class="col-12 text-center mb-5 mt-5">
        <h2>{{ $t("COMMON.BILLING_ADDRESS") }}</h2>
      </div>

      <dl
        class="row"
        v-if="
          salesInvoice.billing_entity_type === BILLING_ENTITY_TYPE_INDIVIDUAL
        "
      >
        <dt class="col-sm-4">{{ $t("COMMON.LASTNAME") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_lastname }}
        </dd>
      </dl>

      <dl
        class="row"
        v-if="
          salesInvoice.billing_entity_type === BILLING_ENTITY_TYPE_INDIVIDUAL
        "
      >
        <dt class="col-sm-4">{{ $t("COMMON.FIRSTNAME") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_firstname }}
        </dd>
      </dl>

      <dl
        class="row"
        v-if="salesInvoice.billing_entity_type === BILLING_ENTITY_TYPE_COMPANY"
      >
        <dt class="col-sm-4">{{ $t("COMMON.COMPANY_NAME") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_company_name }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.COUNTRY") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_country }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.STATE") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_state }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.CITY") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_city }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.ZIPCODE") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_zipcode }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.ADDRESS") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_address }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.EMAIL") }}</dt>
        <dd class="col-sm-8">
          {{ salesInvoice.billing_email }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import {
  BILLING_ENTITY_TYPE_INDIVIDUAL,
  BILLING_ENTITY_TYPE_COMPANY,
} from "@/constants/billingInformations";
import SalesInvoiceStatusBadge from "./SalesInvoiceStatusBadge.vue";

export default {
  name: "sales-invoice-view-global",

  components: {
    SalesInvoiceStatusBadge,
  },

  props: ["salesInvoice"],

  data() {
    return {
      BILLING_ENTITY_TYPE_INDIVIDUAL: BILLING_ENTITY_TYPE_INDIVIDUAL,
      BILLING_ENTITY_TYPE_COMPANY: BILLING_ENTITY_TYPE_COMPANY,
    };
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    salesInvoice(salesInvoice) {},
  },
};
</script>
